import { useMutation } from '@tanstack/react-query';
import { useLocation, useNavigate } from 'react-router';
import { AuthenticationError } from '#api/errors.ts';
import { deleteOrg } from '#api/org.ts';
import type { DeletedAccountState } from '#screens/deleted-account/types.ts';

export function useDeleteAccountMutation(email: string) {
  const navigate = useNavigate();
  const rrLocation = useLocation();

  return useMutation({
    mutationFn: (orgId: string) => deleteOrg(orgId),
    onSuccess: () => {
      const state: DeletedAccountState = { accountDeleted: true };

      void navigate(`/deleted-account?email=${encodeURIComponent(email)}`, { state, replace: true });
    },
    onError: (err) => {
      if (err instanceof AuthenticationError && err.code === 'ERR_2FA_RENEWAL_REQUIRED') {
        // Return the user with 'prefill=true' param, so that the modal re-opens and they just have to submit again.
        void navigate('/auth/mfa/renew', { state: { from: { ...rrLocation, search: 'prefill=true' } }, replace: true });
      }
    },
  });
}
